import { APPLY_PROPERTY } from "../actions/types";

const initialState = {
  appProperty: {
    docs: [],
  },
  loading: true,
};

const applyPropertyReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case APPLY_PROPERTY:
      return {
        ...state,
        appProperty: payload,
        loading: false,
      };

    default:
      return state;
  }
};

export default applyPropertyReducer;
